module.exports = __webpack_public_path__ + "static/4_2_recommendation_DE-500438fe54bf9d4301bcc7dda8939ea9.svg";